// lib/bridgeAbi.js
//
// Minimal ABI fragments for the LIVE mainnet bridge contracts
// (BridgeSenderUpgradeable / BridgeReceiverUpgradeable — see
// solidity/crypto-deposit-contracts/src/stablecoin/bridge/). Just enough for
// viem to encode the customer's calldata and decode the events we need for
// trustless status tracking — no full ABI import, no build-time artifact
// dependency.
//
// Selectors this MUST produce (pinned + verified against the deployed
// contracts 2026-07-14, see cpp/src/bridge/bridge_calldata.hpp for the
// server-side mirror used by the OLD testnet flow — kept in sync manually
// since this app builds calldata independently via viem's encodeFunctionData):
//   approve(address,uint256)                                        0x095ea7b3
//   requestSwap(address,uint256,uint64,address,uint256,bytes32)     0x7f38e58a
//   fulfilled(bytes32)                                               (view)

export const ERC20_APPROVE_ABI = [
  {
    type: 'function',
    name: 'approve',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    outputs: [{ name: '', type: 'bool' }],
  },
];

export const BRIDGE_SENDER_ABI = [
  {
    type: 'function',
    name: 'requestSwap',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'kStable', type: 'address' },
      { name: 'amount', type: 'uint256' },
      { name: 'destChainId', type: 'uint64' },
      { name: 'recipient', type: 'address' },
      { name: 'minOutAmount', type: 'uint256' },
      { name: 'idempotencyKey', type: 'bytes32' },
    ],
    outputs: [{ name: 'swapId', type: 'bytes32' }],
  },
  {
    type: 'event',
    name: 'ChainSwapRequested',
    inputs: [
      { name: 'swapId', type: 'bytes32', indexed: true },
      { name: 'kStable', type: 'address', indexed: true },
      { name: 'amount', type: 'uint256', indexed: false },
      { name: 'netAmount', type: 'uint256', indexed: false },
      { name: 'destChainId', type: 'uint64', indexed: true },
      { name: 'recipient', type: 'address', indexed: false },
      { name: 'sender', type: 'address', indexed: false },
      { name: 'feeWei', type: 'uint256', indexed: false },
      { name: 'gasFeeWei', type: 'uint256', indexed: false },
      { name: 'idempotencyKey', type: 'bytes32', indexed: false },
      { name: 'requestedAt', type: 'uint64', indexed: false },
    ],
  },
];

export const BRIDGE_RECEIVER_ABI = [
  {
    type: 'function',
    name: 'fulfilled',
    stateMutability: 'view',
    inputs: [{ name: 'swapId', type: 'bytes32' }],
    outputs: [{ name: '', type: 'bool' }],
  },
  {
    type: 'event',
    name: 'ChainSwapFulfilled',
    inputs: [
      { name: 'swapId', type: 'bytes32', indexed: true },
      { name: 'kStable', type: 'address', indexed: true },
      { name: 'amount', type: 'uint256', indexed: false },
      { name: 'recipient', type: 'address', indexed: true },
      { name: 'sourceChainId', type: 'uint64', indexed: false },
      { name: 'sourceTxHash', type: 'bytes32', indexed: false },
      { name: 'sourceBlockNumber', type: 'uint64', indexed: false },
      { name: 'operator', type: 'address', indexed: false },
      { name: 'fulfilledAt', type: 'uint64', indexed: false },
    ],
  },
];
